// React
import { useEffect } from "react";

// Amplify
import { fetchAuthSession } from "aws-amplify/auth";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  selectUserGroup,
  setAuthState,
  setUserEmail,
  setUserGroup,
} from "Store/AuthSlice";
import { cacheAuthSessionOptions, clearApiSession } from "Auth/apiSession";
import { clearAppSessionStorage } from "Auth/authUtils";

// Components
import PatientPortal from "../../Users/Patient/PatientPortal";
import AdminPortal from "../../Users/Admin/AdminPortal";
import AutoSignOut from "../AutoSignOut";

const SignedIn = () => {
  const userGroup = useSelector(selectUserGroup);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchCognitoUser = async () => {
      try {
        const cognitoUser = await fetchAuthSession();
        cacheAuthSessionOptions(cognitoUser);
        const userEmail = cognitoUser.tokens.idToken.payload.email;
        const userGroup =
          cognitoUser.tokens.accessToken.payload["cognito:groups"];

        dispatch(setUserEmail(userEmail));
        dispatch(setUserGroup(userGroup[0]));
      } catch {
        clearApiSession();
        clearAppSessionStorage();
        dispatch(setUserEmail(null));
        dispatch(setUserGroup(null));
        dispatch(setAuthState("SignIn"));
      }
    };
    fetchCognitoUser();
  }, [dispatch]);

  const RenderPortal = () => {
    switch (userGroup) {
      case "PATIENT":
        return <PatientPortal />;
      case "ADMIN":
        return <AdminPortal />;
      default:
        return null;
    }
  };

  return (
    <>
      <AutoSignOut />
      <RenderPortal />
    </>
  );
};

export default SignedIn;
